import { Link } from "react-router";

import { Button } from "@/components/ui/button";

interface QueryErrorCardProps {
  /** Actionable copy explaining what failed. */
  message?: string;
  /** When provided, renders a "Try again" button wired to this handler. */
  onRetry?: () => void;
  /** When provided, renders a link back to a safe surface. */
  backTo?: string;
  backLabel?: string;
}

/** Shared error panel for failed queries — one card instead of the ad-hoc
 * "try again / go back" blocks that were duplicated across pages. */
export function QueryErrorCard({
  message = "Something went wrong while loading this data.",
  onRetry,
  backTo,
  backLabel = "Go back",
}: QueryErrorCardProps) {
  return (
    <div className="bg-card border-border rounded-lg border p-8 text-center shadow-sm">
      <p className="text-muted text-sm">{message}</p>
      {(onRetry || backTo) && (
        <div className="mt-4 flex items-center justify-center gap-2">
          {onRetry && (
            <Button variant="outline" size="sm" onClick={onRetry}>
              Try again
            </Button>
          )}
          {backTo && (
            <Button variant="ghost" size="sm" asChild>
              <Link to={backTo}>{backLabel}</Link>
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
